{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://schemas.fortemi.dev/knowledge-shard/1.2.0/record-v1/collection.schema.json",
  "title": "Fortemi Knowledge Shard record-v1 collection record",
  "type": "object",
  "additionalProperties": false,
  "required": ["id", "name", "description", "parent_id", "created_at", "note_count"],
  "properties": {
    "id": {
      "$ref": "#/$defs/uuid"
    },
    "name": {
      "type": "string",
      "minLength": 1
    },
    "description": {
      "type": ["string", "null"]
    },
    "parent_id": {
      "oneOf": [
        {
          "$ref": "#/$defs/uuid"
        },
        {
          "type": "null"
        }
      ]
    },
    "created_at": {
      "type": "string",
      "format": "date-time"
    },
    "note_count": {
      "type": "integer",
      "minimum": 0
    }
  },
  "$defs": {
    "uuid": {
      "type": "string",
      "format": "uuid"
    }
  }
}
